import { ReactNode, useMemo } from "react";
import { useComingSoonStatus } from "@/hooks/useComingSoonStatus";
import { useAuth } from "@/contexts/AuthContext";
import { useLocation } from "react-router-dom";
import ComingSoon from "@/pages/ComingSoon";
import { LoadingScreen } from "@/components/ui/loading-screen";

interface ComingSoonWrapperProps {
  children: ReactNode;
}

export function ComingSoonWrapper({ children }: ComingSoonWrapperProps) {
  const { isComingSoonEnabled, isLoading: comingSoonLoading } =
    useComingSoonStatus();
  const { user, isLoading: authLoading } = useAuth();
  const location = useLocation();

  // Memoize auth paths for better performance
  const authPaths = useMemo(
    () => new Set(["/login", "/forgot-password", "/reset-password"]),
    [],
  );

  const isAuthPage = useMemo(
    () => authPaths.has(location.pathname),
    [authPaths, location.pathname],
  );

  console.log("ComingSoonWrapper - Status:", {
    comingSoonLoading,
    authLoading,
    user: !!user,
    isComingSoonEnabled,
    pathname: location.pathname,
  });

  // Only show loading if we're still checking coming soon status
  if (comingSoonLoading) {
    console.log("ComingSoonWrapper - Showing loading for coming soon check");
    return <LoadingScreen message="Checking availability…" />;
  }

  // If coming soon is enabled and user is not authenticated, show coming soon page
  // EXCEPT for login and password reset pages which should always be accessible
  if (isComingSoonEnabled && !user && !isAuthPage) {
    console.log("ComingSoonWrapper - Showing coming soon page");
    return <ComingSoon />;
  }

  // Otherwise, show the regular app
  console.log("ComingSoonWrapper - Showing regular app");
  return <>{children}</>;
}
